import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, nextTick } from '@nuxtjs/composition-api';
import { metroAreas } from '@/components/partials/jobs/JobsBasicInformation/JobsBasicInformationCity/constants';
import JobsDesiredCriteriaModalFormCityAutocomplete from '@/components/partials/jobs/JobsDesiredCriteriaModal/JobsDesiredCriteriaModalFormCityAutocomplete.vue';
import type { City } from '@/types/graphql';
import JobsDropdown from '~/components/partials/jobs/JobsDropdown/JobsDropdown.vue';

type JobsMetroAreaInputProps = {
  value: string;
  currentCity: City;
};
type JobsMetroAreaInputEmits = {
  (event: 'input', cityId: number | null): void;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'JobsMetroAreaInput',
  props: {
    value: { default: '' },
    currentCity: { default: () => {} }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'input', cityId: number | null): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string, currentCity: City };




const isCustomInputVisible = ref(false);
const predefinedMetroAreas = metroAreas.map(city => ({
  title: city.title,
  key: city.id,
}));
const cityAutocomplete = ref<HTMLElement | null>(null);

const currentCustomLocation = computed(() => (props.currentCity?.id === props.value ? props.currentCity : null));
const isLocationCustom = computed(() => !metroAreas.some(city => city.id === Number(props.value)));
const metroAreaToggleTitle = computed(() => {
  if (!props.value) return null;

  const metroArea = predefinedMetroAreas.find(metroArea => metroArea.key === Number(props.value));
  return metroArea ? metroArea.title : null;
});

onMounted(() => {
  if (isLocationCustom.value) {
    isCustomInputVisible.value = true;
  }
});

function emitValue(cityId: number | null): void {
  emit('input', cityId);
}

function selectMetroArea(cityId: number): void {
  isCustomInputVisible.value = false;

  emitValue(cityId);
}

function showCustomLocationInput(): void {
  emitValue(null);

  isCustomInputVisible.value = true;

  nextTick(() => {
    cityAutocomplete.value?.focus();
  });
}

function saveCustomLocation(cityId: number): void {
  emitValue(cityId);
}

return { __sfc: true,props, emit, isCustomInputVisible, predefinedMetroAreas, cityAutocomplete, currentCustomLocation, isLocationCustom, metroAreaToggleTitle, emitValue, selectMetroArea, showCustomLocationInput, saveCustomLocation, JobsDesiredCriteriaModalFormCityAutocomplete, JobsDropdown }
}

})